import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";

// Styles for PDF
const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 11, fontFamily: "Helvetica" },
  header: { fontSize: 16, marginBottom: 10, textAlign: "center", fontWeight: "bold" },
  section: { marginBottom: 15 },
  sectionTitle: { fontWeight: "bold", textDecoration: "underline", marginBottom: 5 },
  label: { fontWeight: "bold" },
  row: { flexDirection: "row", marginBottom: 5 },
  col: { flex: 1 },
  table: { display: "table", width: "auto", borderWidth: 1, borderColor: "#000", borderStyle: "solid", marginBottom: 10 },
  tableRow: { flexDirection: "row" },
  tableCol: { flex: 1, borderRightWidth: 1, borderColor: "#000", padding: 5 },
  tableColLast: { flex: 1, padding: 5 },
  tableCell: { fontSize: 11 },
});

const IncidentReportPDF = ({ data }) => {
  // Safely parse arrays
  const whoWasInvolved = Array.isArray(data.whoWasInvolved) ? data.whoWasInvolved : [];
  const nameAndRank = Array.isArray(data.nameAndRank) ? data.nameAndRank : [];
  const actionsTaken = Array.isArray(data.actionsTaken) ? data.actionsTaken : [];
  const recommandation = Array.isArray(data.recommandation) ? data.recommandation : [];

  return (
    <Document>
      <Page style={styles.page}>
        {/* Header */}
        <Text style={styles.header}>Incident Report</Text>

        {/* Part A */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>PART A: INCIDENT DETAILS</Text>
          <View style={styles.row}>
            <Text style={styles.label}>Place of Incident: </Text>
            <Text>{data.place || ""}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Location: </Text>
            <Text>{data.location || ""}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Date: </Text>
            <Text>{data.date || ""}</Text>
            <Text style={{ marginLeft: 20, fontWeight: "bold" }}>Time: </Text>
            <Text>{data.time || ""}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Informant Name: </Text>
            <Text>{data.informantName || ""}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Informant NRIC: </Text>
            <Text>{data.informantNRIC || ""}</Text>
          </View>
        </View>

        {/* Parts B - H */}
        {[
          { title: "PART B: WHAT HAPPENED?", field: "what" },
          { title: "PART C: WHEN DID IT HAPPEN?", field: "when" },
          { title: "PART D: WHERE DID IT HAPPEN?", field: "where" },
          { title: "PART E: WHO WAS INVOLVED?", field: "who" },
          { title: "PART F: HOW DID IT HAPPEN?", field: "how" },
          { title: "PART G: WHY DID IT HAPPEN?", field: "why" },
          { title: "PART H: SECURITY IMPLICATIONS", field: "securityImplications" },
        ].map((item, i) => (
          <View style={styles.section} key={i}>
            <Text style={styles.sectionTitle}>{item.title}</Text>
            <Text>{data[item.field] || ""}</Text>
          </View>
        ))}

        {/* Part I - WHO WAS INVOLVED */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>PART I: WHO WAS INVOLVED</Text>
          <Text>{whoWasInvolved.join(", ")}</Text>
        </View>

        {/* Part J - Name & Rank Table */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>PART J: PARTICULARS OF WHO WAS INVOLVED</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Name</Text>
              </View>
              <View style={styles.tableColLast}>
                <Text style={styles.tableCell}>Rank</Text>
              </View>
            </View>
            {nameAndRank.map((nr, i) => (
              <View style={styles.tableRow} key={i}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{nr.name}</Text>
                </View>
                <View style={styles.tableColLast}>
                  <Text style={styles.tableCell}>{nr.rank}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>

        {/* Vehicle & Department */}
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.label}>Vehicle Number: </Text>
            <Text>{data.vehicleNumber || ""}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Department: </Text>
            <Text>{data.department || ""}</Text>
          </View>
        </View>

        {/* Actions Taken Table */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Actions Taken</Text>
          <View style={styles.table}>
            {actionsTaken.map((a, i) => (
              <View style={styles.tableRow} key={i}>
                <View style={styles.tableColLast}>
                  <Text style={styles.tableCell}>{a}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>

        {/* Recommendations Table */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Recommendations</Text>
          <View style={styles.table}>
            {recommandation.map((r, i) => (
              <View style={styles.tableRow} key={i}>
                <View style={styles.tableColLast}>
                  <Text style={styles.tableCell}>{r}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>

      </Page>
    </Document>
  );
};

export default IncidentReportPDF;
